export const loader = {
    startLoader: "START_LOADER",
    stopLoader: "STOP_LOADER",
}
export const auth={
    login:"LOGIN",
    logout:"LOGOUT"
}